export function decodeJwt(token: string): Record<string, unknown> {
  try {
    const payload = token.split('.')[1];
    if (!payload) return {};
    const padded = payload.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(padded)) as Record<string, unknown>;
  } catch {
    return {};
  }
}

export function rolesFromJwt(token: string): string[] {
  const payload = decodeJwt(token);
  const role = payload['role'];
  if (!role) return [];
  if (Array.isArray(role)) return role as string[];
  if (typeof role === 'string') return [role];
  return [];
}
